'use client';

import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useAuth } from '@/hooks/useAuth';

function MomentLogo({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 12 7"
      className={className}
      fill="currentColor"
      style={{ shapeRendering: 'crispEdges' }}
      aria-hidden="true"
    >
      <rect x={5} y={0} width={2} height={1} />
      <rect x={10} y={0} width={2} height={1} />
      <rect x={3} y={1} width={4} height={1} />
      <rect x={8} y={1} width={4} height={1} />
      <rect x={1} y={2} width={11} height={1} />
      <rect x={1} y={3} width={10} height={1} />
      <rect x={0} y={4} width={10} height={1} />
      <rect x={0} y={5} width={4} height={1} />
      <rect x={5} y={5} width={4} height={1} />
      <rect x={0} y={6} width={2} height={1} />
      <rect x={5} y={6} width={2} height={1} />
    </svg>
  );
}

export default function TopBar() {
  const pathname = usePathname();
  const { user, loading: authLoading, logout } = useAuth();
  const isSwarm = pathname === '/swarm';

  return (
    <div className="flex items-center justify-between px-4 py-2 bg-panel-header border-b border-stroke text-[11px] tracking-wider shrink-0">
      <div className="flex items-center gap-3">
        <Link
          href="/"
          onClick={(e) => {
            if (pathname === '/') {
              e.preventDefault();
              window.dispatchEvent(new CustomEvent('moment-logo-click'));
            }
          }}
          className="flex items-center gap-2 text-amber font-bold tracking-[0.12em] hover:text-amber/80 transition-colors"
        >
          <MomentLogo className="h-2.5 w-auto" />
          MOMENT
        </Link>
        {isSwarm && (
          <>
            <span className="text-dim">{'//'}</span>
            <span className="text-secondary uppercase">SWARM Workspace</span>
          </>
        )}
      </div>
      <div className="flex items-center gap-3">
        {user && (
          <div className="flex items-center gap-2">
            {user.avatarUrl && (
              <Image src={user.avatarUrl} alt="" width={16} height={16} className="rounded-full" unoptimized />
            )}
            <span className="text-primary text-[10px]">{user.githubUsername}</span>
            <button
              onClick={logout}
              className="text-dim hover:text-primary text-[10px] cursor-pointer"
            >
              logout
            </button>
          </div>
        )}
        {!user && !authLoading && (
          <a href="/api/auth" className="text-dim hover:text-primary text-[10px]">
            Sign in
          </a>
        )}
        <div className="flex items-center gap-1.5">
          <div
            className="w-1.5 h-1.5 rounded-full bg-green"
            style={{ animation: 'pulse-dot 3s ease-in-out infinite' }}
          />
          <span className="text-green uppercase text-[10px]">Online</span>
        </div>
      </div>
    </div>
  );
}
